import request from '../utils/request';

// 新人活动

export function getNewComersPolite(param) {
    return request({
        url: '/admin/newUserGift/getNewUserGiftList',
        method: 'GET',
        params: param
    })
}

export function createNewComersPolite(data){
    return request({
        url: '/admin/newUserGift/createNewUserGift',
        method: 'POST',
        data: data
    })
}

export function updateNewComersPolite(data){
    return request({
        url: '/admin/newUserGift/updateNewUserGift',
        method: 'PUT',
        data: data
    })
}

export function getNewComersUsers(params){
    return request({
        url: '/admin/newUserGift/getNewUserGiftRecordList',
        method: 'GET',
        params: params
    })
}

export function deleteNewComersPolite(data) {
    return request({
        url: '/admin/newUserGift/deleteNewUserGift',
        method: 'DELETE',
        data
    })
}

// 邀请有礼
export function getInvitationPolite(param) {
    return request({
        url: '/admin/assistGift/getAssistGiftList',
        method: 'GET',
        params: param
    })
}

export function createInvitationPolite(data){
    return request({
        url: '/admin/assistGift/createAssistGift',
        method: 'POST',
        data: data
    })
}

export function updateInvitationPolite(data){
    return request({
        url: '/admin/assistGift/updateAssistGift',
        method: 'PUT',
        data: data
    })
}

export function getInvitationUsers(params){
    return request({
        url: '/admin/assistGift/getAssistGiftRecordList',
        method: 'GET',
        params: params
    })
}
export function deleteInvitationPolite(data) {
    return request({
        url: '/admin/assistGift/deleteAssistGift',
        method: 'DELETE',
        data
    })
}
// 活动弹窗
export function getPopPolite(param) {
    return request({
        url: '/admin/popupGift/getPopupGiftList',
        method: 'GET',
        params: param
    })
}

export function createPopPolite(data){
    return request({
        url: '/admin/popupGift/createPopupGift',
        method: 'POST',
        data: data
    })
}

export function updatePopPolite(data){
    return request({
        url: '/admin/popupGift/updatePopupGift',
        method: 'PUT',
        data: data
    })
}

export function getPopUsers(params){
    return request({
        url: '/admin/popupGift/getPopupGiftRecordList',
        method: 'GET',
        params: params
    })
}
export function deletePopPolite(data) {
    return request({
        url: '/admin/popupGift/deletePopupGift',
        method: 'DELETE',
        data
    })
}
export function getUserLabels(param){
    return request({
        url:'/admin/getLabel',
        method:'GET',
        params:param
    })
}